import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// نضمن أن طلبات POST/PUT/PATCH تُرسل بـ Content-Type: application/json دائماً.
// بعض إصدارات axios 1.x لا تستنتج هذا الترويسة عند تعديل common headers مسبقاً —
// النتيجة: ASP.NET يرد بـ 415 Unsupported Media Type لأن [FromBody] يتوقع JSON.
['post', 'put', 'patch'].forEach((method) => {
    if (!axios.defaults.headers[method]) axios.defaults.headers[method] = {};
    axios.defaults.headers[method]['Content-Type'] = 'application/json';
});

// من مسارات Vue متعددة المقاطع (مثل /Branches/add) الرابط النسبي "api/..." يُحلّ إلى "/Branches/api/..." وليس "/api/..."،
// فيُرجع خادم الواجهة index.html فيُعتقد انتهاء الجلسة. فرض المسارات الجذرية + baseURL يضمن استدعاء واجهات ASP.NET الصحيحة.
if (typeof window !== 'undefined' && window.location && window.location.origin) {
    axios.defaults.baseURL = window.location.origin;
}
axios.interceptors.request.use((config) => {
    const u = config && config.url;
    if (typeof u === 'string' && u.length && !/^https?:\/\//i.test(u) && u.charAt(0) !== '/') {
        config.url = '/' + u;
    }
    return config;
});

// Detect silent auth-redirects: ASP.NET cookie auth replies 302 -> /Login when the cookie is invalid.
// The browser follows the redirect and SPA serves index.html (200 OK + HTML) which would otherwise be
// parsed as a "success" with an empty payload. We surface this as a 401 error so the UI can react.
axios.interceptors.response.use(
    (response) => {
        try {
            const ct = (response && response.headers && (response.headers['content-type'] || response.headers['Content-Type'])) || '';
            const url = (response && response.config && response.config.url) || '';
            const isApiCall = typeof url === 'string' && (url.indexOf('api/') !== -1 || url.indexOf('/Security/') !== -1);
            const looksLikeHtml = typeof ct === 'string' && ct.toLowerCase().indexOf('text/html') !== -1;
            if (isApiCall && looksLikeHtml) {
                if (typeof window !== 'undefined' && window.location && !/\/Login(\?|$)/i.test(window.location.pathname)) {
                    try { window.location.assign('/Login'); } catch (_) { /* ignore */ }
                }
                const err = new Error('انتهت الجلسة. سجّل الدخول مجدداً ثم أعد المحاولة.');
                err.response = { status: 401, data: 'انتهت الجلسة. سجّل الدخول مجدداً ثم أعد المحاولة.' };
                return Promise.reject(err);
            }
        } catch (_) { /* ignore */ }
        return response;
    },
    (error) => Promise.reject(error)
);

//const baseUrl = 'http://localhost:4810/Api';

export default {




    //********************************************************************| Authintecations |***********************************************************

    login(bodyObjeect) {
        return axios.post(`/Security/login`, bodyObjeect);
    },

    IsLoggedin() { 
        return axios.get(`/Security/IsLoggedin`);
    },

    GetFacilityOnboardingStatus() {
        return axios.get(`/Security/FacilityOnboardingStatus`);
    },

    Logout() {
        return axios.post(`/Security/Logout`);
    },





    //// ********************************| Products |********************************


    GetProducts(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Products/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}`);
    },

    /** الأصناف النمطية الصالحة لربط المنتجات (بحث اختياري من الخادم). */
    GetNationalFormularyApproved(search = '', take = 500) {
        const s = encodeURIComponent(search || '');
        return axios.get(`api/admin/NationalFormulary/GetApproved?search=${s}&take=${encodeURIComponent(String(take || 500))}`);
    },

    GetProductsStatistics(productId) {
        const suffix = productId ? `?productId=${productId}` : '';
        return axios.get(`api/admin/Products/GetStatistics${suffix}`);
    },

    GetProductDetails(Id) {
        return axios.get(`api/admin/Products/Get/${Id}`);
    },

    GetAllProducts() {
        return axios.get(`api/admin/Products/GetAll`);
    },

    AddProducts(bodyObject) {
        return axios.post(`api/admin/Products/Add`, bodyObject);
    },

    EditProducts(bodyObject) {
        return axios.post(`api/admin/Products/Edit`, bodyObject);
    },

    ChangeStatusProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/ChangeStatus`);
    },

    DeleteProducts(Id) {
        return axios.post(`api/admin/Products/${Id}/Delete`);
    },

    GetProductPackagings(productId) {
        return axios.get(`api/admin/Products/${productId}/Packagings`);
    },

    // ===== Products Reports =====
    GetProductsReportFilters() {
        return axios.get('api/admin/Products/Reports/Filters');
    },

    GetProductsReportTemplates() {
        return axios.get('api/admin/Products/Reports/Templates');
    },

    ApplyProductsReportTemplate(id) {
        return axios.post(`api/admin/Products/Reports/Templates/${encodeURIComponent(id)}/Apply`);
    },

    SaveProductsReportTemplate(bodyObject) {
        return axios.post('api/admin/Products/Reports/SaveTemplate', bodyObject);
    },

    GenerateProductsReport(bodyObject) {
        return axios.post('api/admin/Products/Reports/Generate', bodyObject);
    },

    ExportProductsReportExcel(bodyObject) {
        return axios.post('api/admin/Products/Reports/ExportExcel', bodyObject, { responseType: 'blob' });
    },

    ExportProductsReportCsv(bodyObject) {
        return axios.post('api/admin/Products/Reports/ExportCsv', bodyObject, { responseType: 'blob' });
    },

    ExportProductsReportPdf(bodyObject) {
        return axios.post('api/admin/Products/Reports/ExportPdf', bodyObject, { responseType: 'blob' });
    },

    SaveProductsReportSchedule(bodyObject) {
        return axios.post('api/admin/Products/Reports/Schedule', bodyObject);
    },

    AddProductPackaging(productId, bodyObject) {
        return axios.post(`api/admin/Products/${productId}/Packagings/Add`, bodyObject);
    },

    EditProductPackaging(Id, bodyObject) {
        return axios.put(`api/admin/Products/Packagings/${Id}`, bodyObject);
    },

    DeleteProductPackaging(Id) {
        return axios.delete(`api/admin/Products/Packagings/${Id}`);
    },



    //ProductsCounts

    GetAllProductsCounts() {
        return axios.get(`api/admin/Products/Counts/GetAll`);
    },

    GetProductsCounts(pageNo, pageSize, Search, stockingId, facilityDepartmentId) {
        const sid = stockingId != null && stockingId !== '' ? `&stockingId=${stockingId}` : '';
        const did = facilityDepartmentId != null && facilityDepartmentId !== '' ? `&facilityDepartmentId=${facilityDepartmentId}` : '';
        return axios.get(`api/admin/Products/Counts/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}${sid}${did}`);
    },


    // ********************************| Products Analytics Dashboard |********************************
    _buildProductsAnalyticsQuery(filters) {
        const f = filters || {};
        const parts = [];
        if (f.categoryId != null && f.categoryId !== '') parts.push(`categoryId=${encodeURIComponent(f.categoryId)}`);
        if (f.manufacturerId != null && f.manufacturerId !== '') parts.push(`manufacturerId=${encodeURIComponent(f.manufacturerId)}`);
        if (f.countryId != null && f.countryId !== '') parts.push(`countryId=${encodeURIComponent(f.countryId)}`);
        if (f.stockingId != null && f.stockingId !== '') parts.push(`stockingId=${encodeURIComponent(f.stockingId)}`);
        if (f.period != null && f.period !== '') parts.push(`period=${encodeURIComponent(f.period)}`);
        if (f.from) parts.push(`from=${encodeURIComponent(f.from)}`);
        if (f.to) parts.push(`to=${encodeURIComponent(f.to)}`);
        if (f.analysisType) parts.push(`analysisType=${encodeURIComponent(f.analysisType)}`);
        if (f.includeInactive) parts.push(`includeInactive=true`);
        if (f.ignoreExpiredBatches) parts.push(`ignoreExpiredBatches=true`);
        return parts.length ? `?${parts.join('&')}` : '';
    },

    GetProductsAnalyticsFilters() {
        return axios.get('api/admin/Products/Analytics/Filters', {
            headers: { 'Cache-Control': 'no-cache' },
            params: { _cb: Date.now() },
        });
    },

    GetProductsAnalyticsKpi(filters) {
        return axios.get(`api/admin/Products/Analytics/Kpi${this._buildProductsAnalyticsQuery(filters)}`);
    },

    GetProductsAnalyticsChartData(filters) {
        return axios.get(`api/admin/Products/Analytics/ChartData${this._buildProductsAnalyticsQuery(filters)}`);
    },

    GetProductsAnalyticsQuickInsights(filters) {
        return axios.get(`api/admin/Products/Analytics/QuickInsights${this._buildProductsAnalyticsQuery(filters)}`);
    },

    GetProductsAnalyticsUrgentProducts(filters) {
        return axios.get(`api/admin/Products/Analytics/UrgentProducts${this._buildProductsAnalyticsQuery(filters)}`);
    },

    ExportProductsAnalyticsPdf(filters) {
        return axios.post('api/admin/Products/Analytics/ExportPdf', filters || {});
    },

    //// ********************************| End Of Products |********************************





    //// ********************************| Financial |********************************

    GetFinancial(pageNo, pageSize, Search, category, counterpartyId) {
        let url = `api/admin/FinancialReports/Ledger?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(Search || '')}`;
        if (category) url += `&category=${encodeURIComponent(category)}`;
        if (counterpartyId) url += `&counterpartyId=${counterpartyId}`;
        return axios.get(url);
    },

    GetFinancialReportsSummary(from, to) {
        let url = 'api/admin/FinancialReports/Summary?';
        if (from) url += `from=${encodeURIComponent(from)}&`;
        if (to) url += `to=${encodeURIComponent(to)}`;
        return axios.get(url);
    },

    GetFinancialReportsStockValue() {
        return axios.get('api/admin/FinancialReports/StockValueByWarehouse');
    },

    /** صرف مباشر من المخزن الرئيسي إلى مرفق */
    GetDirectDispatch(pageNo, pageSize, facilityBranchesId, status) {
        let url = `api/admin/DirectDispatch/Get?pageNo=${pageNo}&pageSize=${pageSize}`;
        if (facilityBranchesId != null && facilityBranchesId !== '') url += `&facilityBranchesId=${facilityBranchesId}`;
        if (status != null && status !== '') url += `&status=${status}`;
        return axios.get(url);
    },
    GetDirectDispatchOne(id) {
        return axios.get(`api/admin/DirectDispatch/${id}`);
    },
    DirectDispatchCreate(bodyObject) {
        return axios.post('api/admin/DirectDispatch/Create', bodyObject);
    },
    DirectDispatchConfirm(id) {
        return axios.post(`api/admin/DirectDispatch/${id}/Confirm`);
    },
    DirectDispatchPrint(id) {
        return axios.post(`api/admin/DirectDispatch/${id}/Print`);
    },
    DirectDispatchCancel(id, reason) {
        return axios.post(`api/admin/DirectDispatch/${id}/Cancel`, { reason: reason || '' });
    },
    DirectDispatchReceive(id, bodyObject) {
        return axios.post(`api/admin/DirectDispatch/${id}/Receive`, bodyObject);
    },



    GetInvoiceNumber(Type) {
        return axios.get(`api/admin/Financial/Invoice/GetInvoiceNumber?Type=${Type}`);
    },

    GetInvoiceIn(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceIn/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },
   
    AddInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Add`, bodyObject);
    },

    EditInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Edit`, bodyObject);
    },

    SaveInvoiceIn(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceIn/Save`, bodyObject);
    },

    ConfirmInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Confirm`);
    },

    CancelInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Cancel`);
    },

    DeleteInvoiceIn(Id) {
        return axios.post(`api/admin/Financial/${Id}/InvoiceIn/Delete`);
    },



    //InvoiceOut
    AddInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Add`, bodyObject);
    },

    SaveInvoiceOut(bodyObject) {
        return axios.post(`api/admin/Financial/InvoiceOut/Save`, bodyObject);
    },

    GetInvoiceOut(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Financial/InvoiceOut/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },




    //Item
    GetInvoiceProducts(Id) {
        return axios.get(`api/admin/Financial/Invoice/Item/Get?Id=${Id}`);
    },

    AddItemToInvoice(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Item/Add`, bodyObject);
    },

    DeleteInvoiceItem(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Item/Delete`);
    },


    //Installments
    GetInvoiceInstallments(Id) {
        return axios.get(`api/admin/Financial/Invoice/Installments/Get?Id=${Id}`);
    },

    AddInstallment(bodyObject) {
        return axios.post(`api/admin/Financial/Invoice/Installments/Add`, bodyObject);
    },

    DeleteInstallment(Id) {
        return axios.post(`api/admin/Financial/${Id}/Invoice/Installments/Delete`);
    },



    //// ********************************| End Of Financial |********************************






    // ********************************| Start Dictionaries |******************************

    // Categories
    GetCategories(pageNo, pageSize, Search, pharmacyControlLevel, status) {
        let url = `api/admin/Dictionaries/Categories/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}`;
        if (pharmacyControlLevel !== undefined && pharmacyControlLevel !== null && pharmacyControlLevel !== '') {
            url += `&pharmacyControlLevel=${pharmacyControlLevel}`;
        }
        if (status !== undefined && status !== null && status !== '') {
            url += `&status=${status}`;
        }
        return axios.get(url);
    },

    GetCategoriesStatistics() {
        return axios.get(`api/admin/Dictionaries/Categories/GetStatistics`);
    },

    GetAllCategories() {
        return axios.get(`api/admin/Dictionaries/Categories/GetAll`);
    },

    AddCategories(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Categories/Add`, bodyObject);
    },

    EditCategories(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Categories/Edit`, bodyObject);
    },

    DeleteCategories(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Categories/Delete`);
    },

    ChangeStatusCategories(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Categories/ChangeStatus`);
    },

    // UnitMeasures (dictionary management)
    GetDictionaryUnitMeasures(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/UnitMeasures/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}`);
    },

    GetAllDictionaryUnitMeasures() {
        return axios.get(`api/admin/Dictionaries/UnitMeasures/GetAll`);
    },

    AddDictionaryUnitMeasure(bodyObject) {
        return axios.post(`api/admin/Dictionaries/UnitMeasures/Add`, bodyObject);
    },

    EditDictionaryUnitMeasure(bodyObject) {
        return axios.post(`api/admin/Dictionaries/UnitMeasures/Edit`, bodyObject);
    },

    DeleteDictionaryUnitMeasure(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/UnitMeasures/Delete`);
    },

    ChangeStatusDictionaryUnitMeasure(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/UnitMeasures/ChangeStatus`);
    },

    // Countries
    GetCountries(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Countries/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCountries() {
        return axios.get(`api/admin/Dictionaries/Countries/GetAll`);
    },

    AddCountries(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Countries/Add`, bodyObject);
    },

    EditCountries(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Countries/Edit`, bodyObject);
    },

    DeleteCountries(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Countries/Delete`);
    },

    ChangeStatusCountries(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Countries/ChangeStatus`);
    },

    // Branches
    GetBranches(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Branches/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllBranches() {
        return axios.get(`api/admin/Dictionaries/Branches/GetAll`);
    },

    AddBranches(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Branches/Add`, bodyObject);
    },

    EditBranches(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Branches/Edit`, bodyObject);
    },

    DeleteBranches(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Branches/Delete`);
    },

    ChangeStatusBranches(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Branches/ChangeStatus`);
    },

    AddBranchWizard(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Branches/WizardAdd`, bodyObject);
    },

    GetBranchesOnboardingQueue() {
        return axios.get(`api/admin/Dictionaries/Branches/OnboardingQueue`);
    },

    PharmacyApproveBranchOnboarding(id) {
        return axios.post(`api/admin/Dictionaries/${id}/Branches/OnboardingPharmacyApprove`);
    },

    MinistryApproveBranchOnboarding(id) {
        return axios.post(`api/admin/Dictionaries/${id}/Branches/OnboardingMinistryApprove`);
    },

    // FacilityDepartments
    GetFacilityDepartments(pageNo, pageSize, Search, branchId) {
        let url = `api/admin/FacilityDepartments/Get?pageNo=${pageNo}&pageSize=${pageSize}&search=${encodeURIComponent(Search || '')}`;
        if (branchId) url += `&branchId=${branchId}`;
        return axios.get(url);
    },

    GetAllFacilityDepartments(branchId, activeOnly = true) {
        let url = `api/admin/FacilityDepartments/GetAll?activeOnly=${activeOnly}`;
        if (branchId) url += `&branchId=${branchId}`;
        return axios.get(url);
    },

    AddFacilityDepartment(bodyObject) {
        return axios.post(`api/admin/FacilityDepartments/Add`, bodyObject);
    },

    EditFacilityDepartment(bodyObject) {
        return axios.post(`api/admin/FacilityDepartments/Edit`, bodyObject);
    },

    DeleteFacilityDepartment(Id) {
        return axios.post(`api/admin/FacilityDepartments/${Id}/Delete`);
    },

    ChangeStatusFacilityDepartment(Id) {
        return axios.post(`api/admin/FacilityDepartments/${Id}/ChangeStatus`);
    },

    // Customers
    GetCustomers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Customers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllCustomers() {
        return axios.get(`api/admin/Dictionaries/Customers/GetAll`);
    },

    AddCustomers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Customers/Add`, bodyObject);
    },

    EditCustomers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Customers/Edit`, bodyObject);
    },

    DeleteCustomers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Customers/Delete`);
    },

    ChangeStatusCustomers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Customers/ChangeStatus`);
    },


    //Suppliers
    GetSuppliers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Suppliers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllSuppliers() {
        return axios.get(`api/admin/Dictionaries/Suppliers/GetAll`);
    },

    AddSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Add`, bodyObject);
    },

    EditSuppliers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Suppliers/Edit`, bodyObject);
    },

    DeleteSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/Delete`);
    },

    ChangeStatusSuppliers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Suppliers/ChangeStatus`);
    },


    // Manufacturers
    GetManufacturers(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Manufacturers/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllManufacturers() {
        return axios.get(`api/admin/Dictionaries/Manufacturers/GetAll`);
    },

    AddManufacturers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Manufacturers/Add`, bodyObject);
    },

    EditManufacturers(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Manufacturers/Edit`, bodyObject);
    },

    DeleteManufacturers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Manufacturers/Delete`);
    },

    ChangeStatusManufacturers(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Manufacturers/ChangeStatus`);
    },



    // Stocking
    GetStocking(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/Stocking/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStocking() {
        return axios.get(`api/admin/Dictionaries/Stocking/GetAll`);
    },

    AddStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Add`, bodyObject);
    },

    EditStocking(bodyObject) {
        return axios.post(`api/admin/Dictionaries/Stocking/Edit`, bodyObject);
    },

    DeleteStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/Delete`);
    },

    ChangeStatusStocking(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/Stocking/ChangeStatus`);
    },

    // Warehouse Management — إدارة المخازن
    GetWarehouses(pageNo, pageSize, search, scope, kind, status) {
        let url = `api/admin/Warehouse/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 25}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (scope) url += `&scope=${encodeURIComponent(scope)}`;
        if (kind !== null && kind !== undefined && kind !== '') url += `&kind=${kind}`;
        if (status !== null && status !== undefined && status !== '') url += `&status=${status}`;
        return axios.get(url);
    },

    GetWarehouseStatistics() {
        return axios.get(`api/admin/Warehouse/GetStatistics`);
    },

    GetWarehouseById(id) {
        return axios.get(`api/admin/Warehouse/Get/${id}`);
    },

    AddWarehouse(bodyObject) {
        return axios.post(`api/admin/Warehouse/Add`, bodyObject);
    },

    EditWarehouse(bodyObject) {
        return axios.post(`api/admin/Warehouse/Edit`, bodyObject);
    },

    ToggleWarehouseStatus(id) {
        return axios.post(`api/admin/Warehouse/${id}/ToggleStatus`);
    },

    ToggleWarehouseFreeze(id) {
        return axios.post(`api/admin/Warehouse/${id}/ToggleFreeze`);
    },

    DeleteWarehouse(id) {
        return axios.post(`api/admin/Warehouse/${id}/Delete`);
    },

    // ─── Dispatch (الصرف) — واجهة موحّدة لعمليات الصرف للمرافق ───
    GetDispatch(pageNo, pageSize, search, facilityBranchesId, status, from, to) {
        let url = `api/admin/Dispatch/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 10}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (facilityBranchesId) url += `&facilityBranchesId=${facilityBranchesId}`;
        if (status != null && status !== '') url += `&status=${status}`;
        if (from) url += `&from=${encodeURIComponent(from)}`;
        if (to) url += `&to=${encodeURIComponent(to)}`;
        return axios.get(url);
    },

    GetDispatchStatistics() {
        return axios.get(`api/admin/Dispatch/GetStatistics`);
    },

    GetDispatchOne(id) {
        return axios.get(`api/admin/Dispatch/Get/${id}`);
    },

    GetDispatchApprovedOrders(facilityBranchesId) {
        let url = `api/admin/Dispatch/GetApprovedOrders`;
        if (facilityBranchesId) url += `?facilityBranchesId=${facilityBranchesId}`;
        return axios.get(url);
    },

    DispatchCreateManual(bodyObject) {
        return axios.post(`api/admin/Dispatch/CreateManual`, bodyObject);
    },

    DispatchCreateDirect(bodyObject) {
        return axios.post(`api/admin/Dispatch/CreateDirect`, bodyObject);
    },

    DispatchCreateFromOrder(orderId) {
        return axios.post(`api/admin/Dispatch/CreateFromOrder/${orderId}`);
    },

    DispatchPrintIssueVoucher(id) {
        return axios.post(`api/admin/Dispatch/${id}/PrintIssueVoucher`);
    },

    DispatchPrintFinalInvoice(id) {
        return axios.post(`api/admin/Dispatch/${id}/PrintFinalInvoice`);
    },

    DispatchConfirmReceipt(id) {
        return axios.post(`api/admin/Dispatch/${id}/ConfirmReceipt`);
    },

    DispatchCancel(id, reason) {
        return axios.post(`api/admin/Dispatch/${id}/Cancel`, { reason: reason || '' });
    },

    // ─── Dispatch (واجهة تجريبية DispatchNew) ───
    GetDispatchAvailableProducts(warehouseId, search) {
        let url = `api/admin/Dispatch/GetAvailableProducts?warehouseId=${warehouseId}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return axios.get(url);
    },

    GetDispatchAvailableBatches(productId, warehouseId) {
        return axios.get(`api/admin/Dispatch/GetAvailableBatches/${productId}/${warehouseId}`);
    },

    GetDispatchOrderItems(orderId) {
        return axios.get(`api/admin/Dispatch/GetOrderItems/${orderId}`);
    },

    GetDispatchOrderRemainingQuantity(orderId, nationalItemId) {
        return axios.get(`api/admin/Dispatch/GetOrderRemainingQuantity/${orderId}/${nationalItemId}`);
    },

    GetDispatchProductBatchesByNationalItem(nationalItemId, warehouseId) {
        return axios.get(`api/admin/Dispatch/GetProductBatchesByNationalItem/${nationalItemId}/${warehouseId}`);
    },

    DispatchAddBatchAllocation(bodyObject) {
        return axios.post(`api/admin/Dispatch/AddBatchAllocation`, bodyObject);
    },

    // ─── Dispatch V2 ───
    GetDispatchV2ApprovedOrderItems(orderId) {
        return axios.get(`api/admin/DispatchV2/GetApprovedOrderItems/${orderId}`);
    },

    GetDispatchV2ProductBatches(productId, warehouseId) {
        return axios.get(`api/admin/DispatchV2/GetProductBatches/${productId}/${warehouseId}`);
    },

    GetProductsByNationalFormularyItem(nationalItemId, warehouseId) {
        return axios.get(`api/admin/Products/GetByNationalFormularyItem/${nationalItemId}/${warehouseId}`);
    },

    DispatchCreate(bodyObject) {
        return axios.post(`api/admin/Dispatch/Create`, bodyObject);
    },

    DispatchAddLine(bodyObject) {
        return axios.post(`api/admin/Dispatch/AddLine`, bodyObject);
    },

    DispatchUpdateLine(bodyObject) {
        return axios.post(`api/admin/Dispatch/UpdateLine`, bodyObject);
    },

    DispatchRemoveLine(bodyObject) {
        return axios.post(`api/admin/Dispatch/RemoveLine`, bodyObject);
    },

    // Inventory Count — الجرد والتسويات (واجهة جديدة موحّدة تحت إدارة المخازن)
    GetInventoryCountList(params) {
        const p = params || {};
        let url = `api/admin/InventoryCount/Get?pageNo=${p.pageNo || 1}&pageSize=${p.pageSize || 25}`;
        if (p.search) url += `&search=${encodeURIComponent(p.search)}`;
        if (p.stockingId) url += `&stockingId=${p.stockingId}`;
        if (p.status !== null && p.status !== undefined && p.status !== '') url += `&status=${p.status}`;
        if (p.from) url += `&from=${encodeURIComponent(p.from)}`;
        if (p.to) url += `&to=${encodeURIComponent(p.to)}`;
        return axios.get(url);
    },

    GetInventoryCountStatistics() {
        return axios.get(`api/admin/InventoryCount/GetStatistics`);
    },

    GetInventoryCountById(id) {
        return axios.get(`api/admin/InventoryCount/Get/${id}`);
    },

    CreateInventoryCountSession(bodyObject) {
        return axios.post(`api/admin/InventoryCount/Create`, bodyObject);
    },

    SaveInventoryCountLines(id, bodyObject) {
        return axios.post(`api/admin/InventoryCount/${id}/SaveLines`, bodyObject);
    },

    SubmitInventoryCountSession(id, bodyObject) {
        return axios.post(`api/admin/InventoryCount/${id}/Submit`, bodyObject || {});
    },

    FinalizeInventoryCountSession(id, bodyObject) {
        return axios.post(`api/admin/InventoryCount/${id}/Finalize`, bodyObject || {});
    },

    CancelInventoryCountSession(id, bodyObject) {
        return axios.post(`api/admin/InventoryCount/${id}/Cancel`, bodyObject || {});
    },

    GetInventoryCountPrintUrl(id) {
        return `/api/admin/InventoryCount/${id}/Print`;
    },

    AddInventoryCountLine(id, bodyObject) {
        // نُسلسل الجسم يدوياً عبر JSON.stringify ونُمرّر Content-Type صراحةً لضمان
        // أن axios لا يُسقط الترويسة في أي إصدار، فيقبله [FromBody] في ASP.NET بأمان.
        const body = JSON.stringify(bodyObject || {});
        return axios.post(
            `api/admin/InventoryCount/${id}/AddLine`,
            body,
            { headers: { 'Content-Type': 'application/json' } }
        );
    },

    GetInventoryCountLookupProducts(search) {
        const s = search ? `?search=${encodeURIComponent(search)}` : '';
        return axios.get(`api/admin/InventoryCount/Lookups/Products${s}`);
    },

    GetInventoryCountLookupUnitMeasures() {
        return axios.get(`api/admin/InventoryCount/Lookups/UnitMeasures`);
    },

    GetInventoryCountLookupCountries() {
        return axios.get(`api/admin/InventoryCount/Lookups/Countries`);
    },

    GetProductWithPackagings(id) {
        return axios.get(`api/admin/Products/GetWithPackagings/${id}`);
    },

    // Inventory Count Periods — إدارة صلاحيات الجرد للمرافق الصحية (فترات ومجموعات) — لإدارة الصيدلة
    GetInventoryCountPeriods(pageNo, pageSize) {
        return axios.get(`api/admin/InventoryCountPeriods/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 25}`);
    },

    GetInventoryCountPeriodById(id) {
        return axios.get(`api/admin/InventoryCountPeriods/Get/${id}`);
    },

    GetInventoryCountPeriodBranches(periodId) {
        return axios.get(`api/admin/InventoryCountPeriods/Lookups/Branches?periodId=${periodId}`);
    },

    CreateInventoryCountPeriod(bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Create`, bodyObject);
    },

    UpdateInventoryCountPeriod(id, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/${id}/Update`, bodyObject);
    },

    CloseInventoryCountPeriod(id) {
        return axios.post(`api/admin/InventoryCountPeriods/${id}/Close`, {});
    },

    AddInventoryCountPeriodGroup(periodId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/${periodId}/Groups/Add`, bodyObject || {});
    },

    UpdateInventoryCountPeriodGroup(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Update`, bodyObject);
    },

    DeleteInventoryCountPeriodGroup(groupId) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Delete`, {});
    },

    AddInventoryCountPeriodGroupBranches(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Branches/Add`, bodyObject);
    },

    RemoveInventoryCountPeriodGroupBranch(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Branches/Remove`, bodyObject);
    },

    ExcludeInventoryCountPeriodGroupBranch(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Branches/Exclude`, bodyObject);
    },

    OpenInventoryCountPeriodGroup(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Open`, bodyObject || {});
    },

    ApproveInventoryCountPeriodGroup(groupId, bodyObject) {
        return axios.post(`api/admin/InventoryCountPeriods/Groups/${groupId}/Approve`, bodyObject || {});
    },

    // Stock Movements (حركات المخزون) — يستخدمها /Warehouse/StockMovements
    _buildStockMovementsQuery(filters) {
        const params = [];
        if (filters) {
            if (filters.pageNo) params.push(`pageNo=${encodeURIComponent(filters.pageNo)}`);
            if (filters.pageSize) params.push(`pageSize=${encodeURIComponent(filters.pageSize)}`);
            if (filters.facilityBranchesId) params.push(`facilityBranchesId=${encodeURIComponent(filters.facilityBranchesId)}`);
            if (filters.stockingId) params.push(`stockingId=${encodeURIComponent(filters.stockingId)}`);
            if (filters.movementCategory) params.push(`movementCategory=${encodeURIComponent(filters.movementCategory)}`);
            if (filters.movementType) params.push(`movementType=${encodeURIComponent(filters.movementType)}`);
            if (filters.search) params.push(`search=${encodeURIComponent(filters.search)}`);
            if (filters.from) params.push(`from=${encodeURIComponent(filters.from)}`);
            if (filters.to) params.push(`to=${encodeURIComponent(filters.to)}`);
        }
        return params.length ? `?${params.join('&')}` : '';
    },

    GetStockMovements(filters) {
        return axios.get(`api/admin/Warehouse/StockMovements/Get${this._buildStockMovementsQuery(filters)}`);
    },

    GetStockMovementsStatistics(filters) {
        const f = { ...(filters || {}) };
        delete f.pageNo; delete f.pageSize; delete f.movementCategory; delete f.movementType; delete f.search;
        return axios.get(`api/admin/Warehouse/StockMovements/GetStatistics${this._buildStockMovementsQuery(f)}`);
    },

    GetStockMovementById(id) {
        return axios.get(`api/admin/Warehouse/StockMovements/Get/${id}`);
    },

    GetStockMovementPrintUrl(id) {
        return `/api/admin/Warehouse/StockMovements/Print/${id}`;
    },

    GetStockMovementsExportExcelUrl(filters) {
        return `/api/admin/Warehouse/StockMovements/ExportExcel${this._buildStockMovementsQuery(filters)}`;
    },

    GetStockMovementsExportPdfUrl(filters) {
        return `/api/admin/Warehouse/StockMovements/ExportPdf${this._buildStockMovementsQuery(filters)}`;
    },

    GetWarehouseMovements(pageNo, pageSize, facilityBranchesId, stockingId, search, from, to) {
        let url = `api/admin/WarehouseReports/Movements?pageno=${pageNo}&pagesize=${pageSize}`;
        if (facilityBranchesId) url += `&facilityBranchesId=${facilityBranchesId}`;
        if (stockingId) url += `&stockingId=${stockingId}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        if (from) url += `&from=${encodeURIComponent(from)}`;
        if (to) url += `&to=${encodeURIComponent(to)}`;
        return axios.get(url);
    },

    GetWarehouseProductLedger(stockingId, productsId, from, to) {
        let url = `api/admin/WarehouseReports/ProductLedger?stockingId=${stockingId}&productsId=${productsId}`;
        if (from) url += `&from=${encodeURIComponent(from)}`;
        if (to) url += `&to=${encodeURIComponent(to)}`;
        return axios.get(url);
    },

    // PaymentsMethods
    GetPaymentsMethods(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllPaymentsMethods() {
        return axios.get(`api/admin/Dictionaries/PaymentsMethods/GetAll`);
    },

    AddPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Add`, bodyObject);
    },

    EditPaymentsMethods(bodyObject) {
        return axios.post(`api/admin/Dictionaries/PaymentsMethods/Edit`, bodyObject);
    },

    DeletePaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/Delete`);
    },

    ChangeStatusPaymentsMethods(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/PaymentsMethods/ChangeStatus`);
    },

    // StorageTemperature
    GetStorageTemperatures(pageNo, pageSize, Search) {
        return axios.get(`api/admin/Dictionaries/StorageTemperature/Get?pageno=${pageNo}&pagesize=${pageSize}&Search=${Search}`);
    },

    GetAllStorageTemperatures() {
        return axios.get(`api/admin/Dictionaries/StorageTemperature/GetAll`);
    },

    AddStorageTemperature(bodyObject) {
        return axios.post(`api/admin/Dictionaries/StorageTemperature/Add`, bodyObject);
    },

    EditStorageTemperature(bodyObject) {
        return axios.post(`api/admin/Dictionaries/StorageTemperature/Edit`, bodyObject);
    },

    DeleteStorageTemperature(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/StorageTemperature/Delete`);
    },

    ChangeStatusStorageTemperature(Id) {
        return axios.post(`api/admin/Dictionaries/${Id}/StorageTemperature/ChangeStatus`);
    },











    //Medicine orders (طلبات دواء من المرافق)
    GetMedicineOrders(pageNo, pageSize, Search, Status, From, To) {
        const params = new URLSearchParams();
        params.append('pageno', pageNo || 1);
        params.append('pagesize', pageSize || 25);
        params.append('Search', Search || '');
        params.append('Status', Status || 0);
        if (From) params.append('From', From);
        if (To) params.append('To', To);
        return axios.get(`api/admin/MedicineOrders/Get?${params.toString()}`);
    },
    GetMedicineOrdersStatistics(From, To) {
        const params = new URLSearchParams();
        if (From) params.append('From', From);
        if (To) params.append('To', To);
        const qs = params.toString();
        return axios.get(`api/admin/MedicineOrders/GetStatistics${qs ? '?' + qs : ''}`);
    },
    GetMedicineOrder(id) {
        return axios.get(`api/admin/MedicineOrders/Get/${id}`);
    },
    MarkMedicineOrderPrinted(id) {
        return axios.post(`api/admin/MedicineOrders/${id}/MarkPrinted`);
    },
    SubmitMedicineOrder(bodyObject) {
        return axios.post(`api/admin/MedicineOrders/Submit`, bodyObject);
    },
    SendMedicineOrder(id) {
        return axios.post(`api/admin/MedicineOrders/Send/${id}`);
    },
    ReviewMedicineOrder(bodyObject) {
        return axios.post(`api/admin/MedicineOrders/Review`, bodyObject);
    },
    DispenseMedicineOrder(bodyObject) {
        return axios.post(`api/admin/MedicineOrders/Dispense`, bodyObject);
    },

    StandaloneDispenseMedicineOrder(bodyObject) {
        return axios.post(`api/admin/MedicineOrders/StandaloneDispense`, bodyObject);
    },

    // Facility orders workflow (طلبات المرافق) - endpoints الجديدة
    GetFacilityProductsForOrders(branchId) {
        const params = branchId ? `?branchId=${branchId}` : '';
        return axios.get(`api/admin/MedicineOrders/FacilityProducts${params}`);
    },
    CreateFacilityOrder(bodyObject, saveOnly) {
        const flag = saveOnly === false ? 'false' : 'true';
        return axios.post(`api/admin/MedicineOrders/Create?saveOnly=${flag}`, bodyObject);
    },
    UpdateFacilityOrder(id, bodyObject) {
        return axios.post(`api/admin/MedicineOrders/${id}/Update`, bodyObject);
    },
    SubmitFacilityOrder(id) {
        return axios.post(`api/admin/MedicineOrders/${id}/Submit`);
    },
    CancelFacilityOrder(id, reason) {
        return axios.post(`api/admin/MedicineOrders/${id}/Cancel`, { reason: reason || null });
    },
    ForceCloseMedicineOrder(id, reason) {
        return axios.post(`api/admin/MedicineOrders/${id}/ForceClose`, { reason: reason || null });
    },
    ConvertFacilityOrderToDispatch(id, body) {
        return axios.post(`api/admin/MedicineOrders/${id}/ConvertToDispatch`, body || {});
    },

    GetReceiptVerifications(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/ReceiptVerification/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetReceiptVerification(id) {
        return axios.get(`api/admin/ReceiptVerification/Get/${id}`);
    },
    MarkReceiptVerificationPrinted(id) {
        return axios.post(`api/admin/ReceiptVerification/${id}/MarkPrinted`);
    },
    GetEligibleReceiptVerificationOrders(search) {
        return axios.get(`api/admin/ReceiptVerification/EligibleOrders?search=${encodeURIComponent(search || '')}`);
    },
    CreateReceiptVerificationFromOrder(orderId) {
        return axios.post(`api/admin/ReceiptVerification/CreateFromOrder/${orderId}`);
    },
    FinalizeReceiptVerification(bodyObject) {
        return axios.post(`api/admin/ReceiptVerification/Finalize`, bodyObject);
    },

    GetReturnOrders(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/ReturnOrders/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetReturnOrder(id) {
        return axios.get(`api/admin/ReturnOrders/Get/${id}`);
    },
    MarkReturnOrderPrinted(id) {
        return axios.post(`api/admin/ReturnOrders/${id}/MarkPrinted`);
    },
    GetEligibleReturnOrders(search) {
        return axios.get(`api/admin/ReturnOrders/EligibleOrders?search=${encodeURIComponent(search || '')}`);
    },
    CreateReturnOrder(bodyObject) {
        return axios.post(`api/admin/ReturnOrders/Create`, bodyObject);
    },
    ReviewReturnOrder(bodyObject) {
        return axios.post(`api/admin/ReturnOrders/Review`, bodyObject);
    },

    GetDamageReports(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/DamageReports/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetDamageReport(id) {
        return axios.get(`api/admin/DamageReports/Get/${id}`);
    },
    MarkDamageReportPrinted(id) {
        return axios.post(`api/admin/DamageReports/${id}/MarkPrinted`);
    },
    GetEligibleDamageBatches(search) {
        return axios.get(`api/admin/DamageReports/EligibleBatches?search=${encodeURIComponent(search || '')}`);
    },
    CreateDamageReport(bodyObject) {
        return axios.post(`api/admin/DamageReports/Create`, bodyObject);
    },
    ReviewDamageReport(bodyObject) {
        return axios.post(`api/admin/DamageReports/Review`, bodyObject);
    },

    GetStockVouchers(pageNo, pageSize, search, voucherType) {
        return axios.get(`api/admin/StockVouchers/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&voucherType=${voucherType || 0}`);
    },
    GetStockVoucher(id) {
        return axios.get(`api/admin/StockVouchers/Get/${id}`);
    },
    MarkStockVoucherPrinted(id) {
        return axios.post(`api/admin/StockVouchers/${id}/MarkPrinted`);
    },
    CreateDepartmentIssueVoucher(bodyObject) {
        return axios.post(`api/admin/StockVouchers/CreateDepartmentIssue`, bodyObject);
    },
    GetDepartmentIssueProducts(sourceStockingId, search) {
        let url = `api/admin/StockVouchers/IssueProducts?sourceStockingId=${sourceStockingId || 0}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return axios.get(url);
    },

    GetWorkflowDefinitions() {
        return axios.get(`api/admin/WorkflowDefinitions/Get`);
    },
    GetWorkflowDefinition(entityType) {
        return axios.get(`api/admin/WorkflowDefinitions/Get/${entityType}`);
    },
    SaveWorkflowDefinition(bodyObject) {
        return axios.post(`api/admin/WorkflowDefinitions/Save`, bodyObject);
    },

    GetNonFormularyRequests(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/NonFormularyRequests/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetNonFormularyRequest(id) {
        return axios.get(`api/admin/NonFormularyRequests/Get/${id}`);
    },
    MarkNonFormularyRequestPrinted(id) {
        return axios.post(`api/admin/NonFormularyRequests/${id}/MarkPrinted`);
    },
    CreateNonFormularyRequest(bodyObject) {
        return axios.post(`api/admin/NonFormularyRequests/Create`, bodyObject);
    },
    ReviewNonFormularyRequest(bodyObject) {
        return axios.post(`api/admin/NonFormularyRequests/Review`, bodyObject);
    },
    GetProductAdditionRequests(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/ProductAdditionRequests/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetProductAdditionRequest(id) {
        return axios.get(`api/admin/ProductAdditionRequests/Get/${id}`);
    },
    GetProductAdditionUnitMeasures() {
        return axios.get(`api/admin/ProductAdditionRequests/UnitMeasures`);
    },
    CheckProductAdditionSimilar(productName, nationalFormularyItemId) {
        return axios.get(`api/admin/ProductAdditionRequests/CheckSimilar?productName=${encodeURIComponent(productName || '')}&nationalFormularyItemId=${nationalFormularyItemId || 0}`);
    },
    CreateProductAdditionRequest(bodyObject) {
        return axios.post(`api/admin/ProductAdditionRequests/Create`, bodyObject);
    },
    ReviewProductAdditionRequest(bodyObject) {
        return axios.post(`api/admin/ProductAdditionRequests/Review`, bodyObject);
    },

    GetBranchNationalFormularyGrid(pageNo, pageSize, search, scope, facilityBranchesId, filters) {
        let url = `api/admin/BranchNationalFormulary/Grid?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&scope=${encodeURIComponent(scope || 'all')}`;
        if (facilityBranchesId != null && facilityBranchesId !== '') url += `&facilityBranchesId=${facilityBranchesId}`;
        const f = filters || {};
        if (f.categoryId != null && f.categoryId !== '') url += `&categoryId=${encodeURIComponent(f.categoryId)}`;
        if (f.codePrefix) url += `&codePrefix=${encodeURIComponent(f.codePrefix)}`;
        if (f.codeFrom) url += `&codeFrom=${encodeURIComponent(f.codeFrom)}`;
        if (f.codeTo) url += `&codeTo=${encodeURIComponent(f.codeTo)}`;
        if (f.descriptionSearch) url += `&descriptionSearch=${encodeURIComponent(f.descriptionSearch)}`;
        return axios.get(url);
    },

    GetBranchNationalFormularyNationalPickerGrid(pageNo, pageSize, search, filters) {
        let url = `api/admin/BranchNationalFormulary/NationalPickerGrid?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}`;
        const f = filters || {};
        if (f.categoryId != null && f.categoryId !== '') url += `&categoryId=${encodeURIComponent(f.categoryId)}`;
        if (f.codePrefix) url += `&codePrefix=${encodeURIComponent(f.codePrefix)}`;
        if (f.codeFrom) url += `&codeFrom=${encodeURIComponent(f.codeFrom)}`;
        if (f.codeTo) url += `&codeTo=${encodeURIComponent(f.codeTo)}`;
        if (f.descriptionSearch) url += `&descriptionSearch=${encodeURIComponent(f.descriptionSearch)}`;
        // طلب صريح بعدم الاعتماد على نسخة مخزّنة — 304 قد تُفضي إلى response.data فارغ في المتصفح.
        return axios.get(url, {
            headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
            params: { _cb: Date.now() },
        });
    },

    GetBranchNationalFormularyCategories() {
        return axios.get(`api/admin/BranchNationalFormulary/FormularyCategories`, {
            headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
            params: { _cb: Date.now() },
        });
    },

    ResolveBranchNationalFormularyCodes(codesArray, facilityBranchesId) {
        return axios.post(`api/admin/BranchNationalFormulary/ResolveNationalCodes`, {
            codes: codesArray || [],
            facilityBranchesId: facilityBranchesId != null && facilityBranchesId !== '' ? facilityBranchesId : null,
        });
    },

    ResolveBranchNationalFormularyCodesExcel(file, facilityBranchesId) {
        const fd = new FormData();
        fd.append('file', file);
        let url = `api/admin/BranchNationalFormulary/ResolveNationalCodesExcel`;
        if (facilityBranchesId != null && facilityBranchesId !== '') url += `?facilityBranchesId=${facilityBranchesId}`;
        return axios.post(url, fd, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    GetBranchNationalFormularyRequests(pageNo, pageSize, status, facilityBranchesId) {
        let url = `api/admin/BranchNationalFormulary/Requests?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&status=${status || 0}`;
        if (facilityBranchesId != null && facilityBranchesId !== '') url += `&facilityBranchesId=${facilityBranchesId}`;
        return axios.get(url);
    },
    GetBranchNationalFormularyRequestById(id, facilityBranchesId) {
        let url = `api/admin/BranchNationalFormulary/Requests/${id}`;
        if (facilityBranchesId != null && facilityBranchesId !== '') url += `?facilityBranchesId=${facilityBranchesId}`;
        return axios.get(url);
    },
    CreateBranchNationalFormularyRequest(bodyObject) {
        return axios.post(`api/admin/BranchNationalFormulary/Requests/Create`, bodyObject);
    },
    ReviewBranchNationalFormularyRequest(bodyObject) {
        return axios.post(`api/admin/BranchNationalFormulary/Requests/Review`, bodyObject);
    },
    BranchNationalFormularyGrantsAdd(bodyObject) {
        return axios.post(`api/admin/BranchNationalFormulary/Grants/Add`, bodyObject);
    },
    BranchNationalFormularyGrantsRevoke(bodyObject) {
        return axios.post(`api/admin/BranchNationalFormulary/Grants/Revoke`, bodyObject);
    },

    GetExternalPurchaseRequests(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/ExternalPurchaseRequests/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetExternalPurchaseRequest(id) {
        return axios.get(`api/admin/ExternalPurchaseRequests/Get/${id}`);
    },
    MarkExternalPurchaseRequestPrinted(id) {
        return axios.post(`api/admin/ExternalPurchaseRequests/${id}/MarkPrinted`);
    },
    CreateExternalPurchaseRequest(bodyObject) {
        return axios.post(`api/admin/ExternalPurchaseRequests/Create`, bodyObject);
    },
    ReviewExternalPurchaseRequest(bodyObject) {
        return axios.post(`api/admin/ExternalPurchaseRequests/Review`, bodyObject);
    },

    ReceiveExternalPurchaseRequest(id, bodyObject) {
        return axios.post(`api/admin/ExternalPurchaseRequests/${id}/Receive`, bodyObject);
    },

    GetSurplusRequests(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/SurplusRequests/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetSurplusRequest(id) {
        return axios.get(`api/admin/SurplusRequests/Get/${id}`);
    },
    MarkSurplusRequestPrinted(id) {
        return axios.post(`api/admin/SurplusRequests/${id}/MarkPrinted`);
    },
    CreateSurplusRequest(bodyObject) {
        return axios.post(`api/admin/SurplusRequests/Create`, bodyObject);
    },
    ReviewSurplusRequest(bodyObject) {
        return axios.post(`api/admin/SurplusRequests/Review`, bodyObject);
    },

    GetRotationTransfers(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/RotationTransfers/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetRotationTransfer(id) {
        return axios.get(`api/admin/RotationTransfers/Get/${id}`);
    },
    ExecuteRotationTransfer(bodyObject) {
        return axios.post(`api/admin/RotationTransfers/Execute`, bodyObject);
    },

    GetInventoryCounts(pageNo, pageSize, search, status) {
        return axios.get(`api/admin/InventoryCounts/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}&status=${status || 0}`);
    },
    GetInventoryCount(id) {
        return axios.get(`api/admin/InventoryCounts/Get/${id}`);
    },
    MarkInventoryCountPrinted(id) {
        return axios.post(`api/admin/InventoryCounts/${id}/MarkPrinted`);
    },
    CreateInventoryCount(bodyObject) {
        return axios.post(`api/admin/InventoryCounts/Create`, bodyObject);
    },
    SubmitInventoryCount(bodyObject) {
        return axios.post(`api/admin/InventoryCounts/Submit`, bodyObject);
    },
    FinalizeInventoryCount(bodyObject) {
        return axios.post(`api/admin/InventoryCounts/Finalize`, bodyObject);
    },

    DownloadOpeningStockTemplate(stockingId) {
        return axios.get(`api/admin/InventoryCounts/OpeningStockTemplate?stockingId=${stockingId}`, { responseType: 'blob' });
    },

    ImportOpeningStock(formData) {
        return axios.post(`api/admin/InventoryCounts/ImportOpeningStock`, formData);
    },

    GetGrantedOpeningProducts(stockingId, pageNo, pageSize, search) {
        return axios.get(
            `api/admin/InventoryCounts/GrantedOpeningProducts?stockingId=${stockingId}&pageNo=${pageNo || 1}&pageSize=${pageSize || 100}&search=${encodeURIComponent(search || '')}`
        );
    },

    GetInventoryUiContext() {
        return axios.get('api/admin/InventoryCounts/UiContext');
    },
    GetInventoryAggregatedLines(pageNo, pageSize, search, facilityDepartmentId, expiryFrom, expiryTo, sessionStatus) {
        const did = facilityDepartmentId && Number(facilityDepartmentId) > 0 ? `&facilityDepartmentId=${Number(facilityDepartmentId)}` : '';
        const ef = expiryFrom ? `&expiryFrom=${encodeURIComponent(expiryFrom)}` : '';
        const et = expiryTo ? `&expiryTo=${encodeURIComponent(expiryTo)}` : '';
        const st = sessionStatus && Number(sessionStatus) > 0 ? `&sessionStatus=${Number(sessionStatus)}` : '';
        return axios.get(
            `api/admin/InventoryCounts/AggregatedLines?pageNo=${pageNo || 1}&pageSize=${pageSize || 50}&search=${encodeURIComponent(search || '')}${did}${ef}${et}${st}`
        );
    },
    GetInventoryUnifiedReport(search, facilityDepartmentId, expiryFrom, expiryTo) {
        const did = facilityDepartmentId && Number(facilityDepartmentId) > 0 ? `&facilityDepartmentId=${Number(facilityDepartmentId)}` : '';
        const ef = expiryFrom ? `&expiryFrom=${encodeURIComponent(expiryFrom)}` : '';
        const et = expiryTo ? `&expiryTo=${encodeURIComponent(expiryTo)}` : '';
        return axios.get(
            `api/admin/InventoryCounts/UnifiedQuantityReport?search=${encodeURIComponent(search || '')}${did}${ef}${et}`
        );
    },
    SaveInventoryLineQuantities(bodyObject) {
        return axios.post('api/admin/InventoryCounts/SaveLineQuantities', bodyObject);
    },
    // ملاحظة: مستخدمة من واجهة InventoryCounts (الجمع) القديمة فقط — لا تخلط بينها
    // وبين AddInventoryCountLine(id, body) أعلاه التي تستخدمها واجهة التفاصيل الجديدة
    // (InventoryCountDetails) عبر POST /api/admin/InventoryCount/{id}/AddLine.
    // كان الاسم متكرراً فيُسقط تعريف الأعلى ويستدعى هذا بدلاً منه مع وسيطات خاطئة.
    AddInventoryCountsLegacyLine(bodyObject) {
        return axios.post('api/admin/InventoryCounts/AddLine', bodyObject);
    },
    /** بحث أصناف إضافة سطر الجرد من القائمة النمطية (منح المرفق / أصناف نمطية). */
    GetInventoryAddLineProducts(sessionId, pageNo, pageSize, search) {
        const sid = Number(sessionId) || 0;
        const p = pageNo || 1;
        const s = pageSize || 40;
        const q = search != null ? encodeURIComponent(search) : '';
        return axios.get(
            `api/admin/InventoryCounts/AddLineLookup/Products?sessionId=${sid}&pageNo=${p}&pageSize=${s}&search=${q}`
        );
    },
    GetInventoryAddLineTradeNames(sessionId, productsId) {
        const sid = Number(sessionId) || 0;
        const pid = Number(productsId) || 0;
        return axios.get(`api/admin/InventoryCounts/AddLineLookup/TradeNames?sessionId=${sid}&productsId=${pid}`);
    },
    GetInventoryAddLineBatches(sessionId, productsId, tradeName) {
        const sid = Number(sessionId) || 0;
        const pid = Number(productsId) || 0;
        const t = tradeName != null ? encodeURIComponent(tradeName) : '';
        return axios.get(
            `api/admin/InventoryCounts/AddLineLookup/Batches?sessionId=${sid}&productsId=${pid}&tradeName=${t}`
        );
    },
    CancelInventoryCountLine(lineId) {
        return axios.post(`api/admin/InventoryCounts/Lines/${lineId}/Cancel`);
    },

    GetInventoryAlerts(nearExpiryDays) {
        return axios.get(`api/admin/InventoryAlerts/Get?nearExpiryDays=${nearExpiryDays || 60}`);
    },

    // حد الطلب: تعديل الحد لصنف نمطي من شاشة تنبيهات المخزون (للمرفق)
    SetInventoryReorderLevel(bodyObject) {
        return axios.post(`api/admin/InventoryAlerts/SetReorderLevel`, bodyObject);
    },

    // ─── إعادة التدوير (الرواكد وقرب انتهاء الصلاحية) ───────────────────────
    // جهة المرفق
    GetRecycleCandidates(params) {
        const p = params || {};
        const q = [];
        if (p.stagnantDays) q.push(`stagnantDays=${p.stagnantDays}`);
        if (p.nearExpiryDays) q.push(`nearExpiryDays=${p.nearExpiryDays}`);
        return axios.get(`api/admin/RecycleRequests/Candidates${q.length ? '?' + q.join('&') : ''}`);
    },

    GetRecycleRequests(params) {
        const p = params || {};
        let url = `api/admin/RecycleRequests/Get?pageNo=${p.pageNo || 1}&pageSize=${p.pageSize || 25}`;
        if (p.status) url += `&status=${p.status}`;
        if (p.branchId) url += `&branchId=${p.branchId}`;
        if (p.search) url += `&search=${encodeURIComponent(p.search)}`;
        return axios.get(url);
    },

    GetRecycleRequestById(id) {
        return axios.get(`api/admin/RecycleRequests/Get/${id}`);
    },

    CreateRecycleRequest(bodyObject, saveOnly) {
        const flag = saveOnly === false ? 'false' : 'true';
        return axios.post(`api/admin/RecycleRequests/Create?saveOnly=${flag}`, bodyObject);
    },

    UpdateRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Update`, bodyObject);
    },

    SubmitRecycleRequest(id) {
        return axios.post(`api/admin/RecycleRequests/${id}/Submit`, {});
    },

    CancelRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Cancel`, bodyObject || {});
    },

    ConfirmRecycleReceipt(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/ConfirmReceipt`, bodyObject || {});
    },

    // جهة إدارة الصيدلة
    ApproveRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Approve`, bodyObject || {});
    },

    RejectRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Reject`, bodyObject);
    },

    RouteRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Route`, bodyObject);
    },

    ReleaseRecycleRequest(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/Release`, bodyObject);
    },

    MarkRecycleDelivered(id, bodyObject) {
        return axios.post(`api/admin/RecycleRequests/${id}/MarkDelivered`, bodyObject || {});
    },

    GetRecycleBeneficiaries(requestId) {
        return axios.get(`api/admin/RecycleRequests/Lookups/Beneficiaries?requestId=${requestId}`);
    },

    // ─── بيانات الاحتياج الطبي المسبق والتقديري ─────────────────────────────
    GetNeedEstimatesSheet(branchId, search) {
        const q = [];
        if (branchId) q.push(`branchId=${branchId}`);
        if (search) q.push(`search=${encodeURIComponent(search)}`);
        return axios.get(`api/admin/NeedEstimates/BranchSheet${q.length ? '?' + q.join('&') : ''}`);
    },

    SaveNeedEstimates(bodyObject) {
        return axios.post(`api/admin/NeedEstimates/Save`, bodyObject);
    },

    GetNeedEstimatesByProduct(formularyItemId) {
        return axios.get(`api/admin/NeedEstimates/ByProduct?formularyItemId=${formularyItemId}`);
    },

    SearchNeedFormularyItems(search) {
        const s = search ? `?search=${encodeURIComponent(search)}` : '';
        return axios.get(`api/admin/NeedEstimates/Lookups/FormularyItems${s}`);
    },

    GetNotifications(pageNo, pageSize, unreadOnly) {
        return axios.get(`api/admin/Notifications/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&unreadOnly=${!!unreadOnly}`);
    },

    GetNotificationsSummary() {
        return axios.get('api/admin/Notifications/Summary');
    },

    MarkNotificationRead(id) {
        return axios.post('api/admin/Notifications/MarkRead', { id });
    },

    MarkAllNotificationsRead() {
        return axios.post('api/admin/Notifications/MarkAllRead');
    },

    /** قائمة نمطية عامة (قراءة) — بدون تسجيل دخول عند تفعيل المسار العام */
    GetPublicFormulary(pageNo, pageSize, search) {
        const p = pageNo || 1;
        const s = pageSize || 50;
        const q = search != null ? encodeURIComponent(search) : '';
        return axios.get(`api/public/Formulary/List?pageNo=${p}&pageSize=${s}&search=${q}`);
    },

    GetFormulary(pageNo, pageSize, search) {
        return axios.get(`api/admin/Formulary/Get?pageNo=${pageNo || 1}&pageSize=${pageSize || 20}&search=${encodeURIComponent(search || '')}`);
    },

    DownloadFormularyTemplate() {
        return axios.get('api/admin/Formulary/DownloadTemplate', { responseType: 'blob' });
    },

    AddFormulary(bodyObject) {
        return axios.post('api/admin/Formulary/Add', bodyObject);
    },

    EditFormulary(bodyObject) {
        return axios.post('api/admin/Formulary/Edit', bodyObject);
    },

    DeleteFormulary(id) {
        return axios.post(`api/admin/Formulary/${id}/Delete`);
    },

    ImportFormulary(file, showOnPublicFormulary = true) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('showOnPublicFormulary', showOnPublicFormulary);
        return axios.post('api/admin/Formulary/Import', formData);
    },

    // القائمة النمطية — سير الاعتماد الثنائي
    GetFormularyPendingReview(pageNo, pageSize, search) {
        return axios.get(`api/admin/Formulary/PendingReview?pageNo=${pageNo || 1}&pageSize=${pageSize || 50}&search=${encodeURIComponent(search || '')}`);
    },
    ReviewFormularyPharmacy(bodyObject) {
        return axios.post('api/admin/Formulary/ReviewPharmacy', bodyObject);
    },
    ApproveFormularyMinistry(bodyObject) {
        return axios.post('api/admin/Formulary/ApproveMinistry', bodyObject);
    },

    // تقارير المخزون
    GetInventoryDashboard(branchId) {
        const b = branchId ? `?branchId=${branchId}` : '';
        return axios.get(`api/admin/WarehouseReports/Dashboard${b}`);
    },
    GetInventoryReportDetailed(pageNo, pageSize, branchId, stockingId, search) {
        let url = `api/admin/WarehouseReports/DetailedStock?pageNo=${pageNo || 1}&pageSize=${pageSize || 50}`;
        if (branchId) url += `&branchId=${branchId}`;
        if (stockingId) url += `&stockingId=${stockingId}`;
        if (search) url += `&search=${encodeURIComponent(search)}`;
        return axios.get(url);
    },
    GetInventoryReportMovements(pageNo, pageSize, branchId, stockingId, fromDate, toDate) {
        let url = `api/admin/WarehouseReports/Movements?pageNo=${pageNo || 1}&pageSize=${pageSize || 50}`;
        if (branchId) url += `&branchId=${branchId}`;
        if (stockingId) url += `&stockingId=${stockingId}`;
        if (fromDate) url += `&fromDate=${fromDate}`;
        if (toDate) url += `&toDate=${toDate}`;
        return axios.get(url);
    },
    GetInventoryExpirySummary(branchId) {
        const b = branchId ? `?branchId=${branchId}` : '';
        return axios.get(`api/admin/WarehouseReports/ExpirySummary${b}`);
    },

    // ─── تقارير المخزون (Stock Reports) ─────────────────────────────
    _buildStockReportQuery(filters) {
        const params = [];
        if (filters) {
            const map = [
                'pageNo', 'pageSize', 'sortBy', 'sortDir', 'branchId', 'stockingId',
                'categoryId', 'manufacturerId', 'countryId',
                'expiryFrom', 'expiryTo', 'search', 'windowDays', 'tab'
            ];
            for (const key of map) {
                const v = filters[key];
                if (v !== undefined && v !== null && v !== '') {
                    params.push(`${key}=${encodeURIComponent(v)}`);
                }
            }
        }
        return params.length ? `?${params.join('&')}` : '';
    },

    GetStockReportMetrics(filters) {
        return axios.get(`api/admin/Reports/Stock/GetMetrics${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportCurrent(filters) {
        return axios.get(`api/admin/Reports/Stock/Current${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportExpired(filters) {
        return axios.get(`api/admin/Reports/Stock/Expired${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportExpiringSoon(filters) {
        return axios.get(`api/admin/Reports/Stock/ExpiringSoon${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportLowStock(filters) {
        return axios.get(`api/admin/Reports/Stock/LowStock${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportByWarehouse(filters) {
        return axios.get(`api/admin/Reports/Stock/ByWarehouse${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportByCategory(filters) {
        return axios.get(`api/admin/Reports/Stock/ByCategory${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportLastInventory(filters) {
        return axios.get(`api/admin/Reports/Stock/LastInventory${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportChartsData(filters) {
        return axios.get(`api/admin/Reports/Stock/ChartsData${this._buildStockReportQuery(filters)}`);
    },
    GetStockReportExportExcelUrl(filters) {
        return `/api/admin/Reports/Stock/ExportExcel${this._buildStockReportQuery(filters)}`;
    },
    GetStockReportExportPdfUrl(filters) {
        return `/api/admin/Reports/Stock/ExportPdf${this._buildStockReportQuery(filters)}`;
    },

    GetUnitMeasures() {
        return axios.get('api/admin/ProductPackaging/UnitMeasures');
    },

    GetProductPackaging(productId) {
        return axios.get(`api/admin/ProductPackaging/${productId}/Get`);
    },

    SaveProductPackaging(productId, lines) {
        return axios.post(`api/admin/ProductPackaging/${productId}/Save`, { lines: lines || [] });
    },

    //Dashboard
    GetDashboardInfo() {
        return axios.get(`api/admin/Dictionaries/Dashboard/Get`);
    },



    // ********************************| End Dictionaries |********************************










    // ********************************| Users |********************************
    GetUsers(pageNo, pageSize, Search, status, userType) {
        const s = status === undefined || status === null ? 0 : status;
        const t = userType === undefined || userType === null || userType === '' ? 0 : userType;
        return axios.get(`api/admin/Users/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}&status=${s}&userType=${t}`);
    },
    GetUsersStatistics() {
        return axios.get('api/admin/Users/GetStatistics');
    },
    GetBranchUsers(pageNo, pageSize, Search, status) {
        const s = status === undefined || status === null ? 0 : status;
        return axios.get(`api/admin/Users/Branch/Get?pageNo=${pageNo}&pagesize=${pageSize}&Search=${encodeURIComponent(Search || '')}&status=${s}`);
    },
    AddBranchUser(bodyObject) {
        return axios.post('api/admin/Users/Branch/Add', bodyObject);
    },
    EditBranchUser(bodyObject) {
        return axios.post('api/admin/Users/Branch/Edit', bodyObject);
    },

    GetUsersTransactions(pageNoT, pageSizeT, Id) {
        return axios.get(`api/admin/Users/GetTransactions?pageNo=${pageNoT}&pagesize=${pageSizeT}&Id=${Id}`);
    },

    GetAllUsers() {
        return axios.get(`api/admin/Users/GetAll`);
    },

    AddUsers(bodyObject) {
        return axios.post('api/admin/Users/Add', bodyObject);
    },

    EditUsers(bodyObject) {
        return axios.post('api/admin/Users/Edit', bodyObject);
    },

    ResetPasswordUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ResetPassword`);
    },

    ChangeStatusUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/ChangeStatus`);
    },

    DeleteUsers(Id) {
        return axios.post(`api/admin/Users/${Id}/Delete`);
    },


    //USerProfile 
    ChangeProfilePicture(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePicture', bodyObject);
    },

    ChangeProfileInfo(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangeInfo', bodyObject);
    },

    ChangeProfilePassword(bodyObject) {
        return axios.post('api/admin/Users/Profile/ChangePassword', bodyObject);
    },



    // ********************************| End Of Users |********************************



    // ─── System Settings (إعدادات النظام) ─────────────────────────────
    GetSystemSettings() {
        return axios.get('api/admin/Settings/Get');
    },
    UpdateSystemSettings(body) {
        return axios.post('api/admin/Settings/Update', body);
    },
    ResetSystemSettings() {
        return axios.post('api/admin/Settings/Reset');
    },


    // ─── Main Dashboard (لوحة التحكم الرئيسية) ─────────────────────────────
    GetMainDashboardCards() {
        return axios.get(`api/admin/Dashboard/GetCards`);
    },
    GetMainDashboardChartsData() {
        return axios.get(`api/admin/Dashboard/GetChartsData`);
    },
    GetMainDashboardRecentActivities() {
        return axios.get(`api/admin/Dashboard/GetRecentActivities`);
    },
    GetMinisterDashboardData() {
        return axios.get(`api/admin/Dashboard/GetMinisterDashboardData`);
    },


    // ─── Comprehensive Reports (التقارير الشاملة) ─────────────────────────────
    _buildComprehensiveQuery(filters) {
        const params = [];
        if (filters) {
            const map = ['period', 'from', 'to', 'branchesId', 'categoryId'];
            for (const key of map) {
                const v = filters[key];
                if (v !== undefined && v !== null && v !== '') {
                    params.push(`${key}=${encodeURIComponent(v)}`);
                }
            }
        }
        return params.length ? `?${params.join('&')}` : '';
    },
    GetComprehensiveReportMetrics(filters) {
        return axios.get(`api/admin/Reports/Comprehensive/GetMetrics${this._buildComprehensiveQuery(filters)}`);
    },
    GetComprehensiveReportChartsData(filters) {
        return axios.get(`api/admin/Reports/Comprehensive/GetChartsData${this._buildComprehensiveQuery(filters)}`);
    },
    GetComprehensiveReportFinancialData(filters) {
        return axios.get(`api/admin/Reports/Comprehensive/GetFinancialData${this._buildComprehensiveQuery(filters)}`);
    },
    GetComprehensiveReportStatisticsData(filters) {
        return axios.get(`api/admin/Reports/Comprehensive/GetStatisticsData${this._buildComprehensiveQuery(filters)}`);
    },
    GetComprehensiveReportExportExcelUrl(filters) {
        return `/api/admin/Reports/Comprehensive/ExportExcel${this._buildComprehensiveQuery(filters)}`;
    },
    GetComprehensiveReportExportPdfUrl(filters) {
        return `/api/admin/Reports/Comprehensive/ExportPdf${this._buildComprehensiveQuery(filters)}`;
    },


    // ─── Official Vouchers (السندات الرسمية الموحَّدة) ─────────────────────────────
    _buildVouchersQuery(filters) {
        const params = [];
        if (filters) {
            const map = ['pageNo', 'pageSize', 'Search', 'Type', 'BranchesId', 'From', 'To'];
            for (const key of map) {
                const v = filters[key];
                if (v !== undefined && v !== null && v !== '') {
                    params.push(`${key}=${encodeURIComponent(v)}`);
                }
            }
        }
        return params.length ? `?${params.join('&')}` : '';
    },
    GetOfficialVouchers(filters) {
        return axios.get(`api/admin/Vouchers/Get${this._buildVouchersQuery(filters)}`);
    },
    GetOfficialVouchersStatistics(filters) {
        return axios.get(`api/admin/Vouchers/GetStatistics${this._buildVouchersQuery(filters)}`);
    },
    GetOfficialVoucherOne(source, id) {
        return axios.get(`api/admin/Vouchers/Get/${id}?type=${encodeURIComponent(source)}`);
    },
    GetOfficialVoucherPrintUrl(source, id) {
        return `/api/admin/Vouchers/Print/${id}?type=${encodeURIComponent(source)}`;
    },


    // ─── Pharmacy Dashboard (لوحة مراجعة الصيدلة) ─────────────────────────────
    GetPharmacyOrders(pageNo, pageSize, Search, Status, BranchesId, From, To) {
        const params = [
            `pageNo=${pageNo || 1}`,
            `pageSize=${pageSize || 25}`,
        ];
        if (Search) params.push(`Search=${encodeURIComponent(Search)}`);
        if (Status !== undefined && Status !== null && Status !== '') params.push(`Status=${Status}`);
        if (BranchesId !== undefined && BranchesId !== null && BranchesId !== '') params.push(`BranchesId=${BranchesId}`);
        if (From) params.push(`From=${encodeURIComponent(From)}`);
        if (To) params.push(`To=${encodeURIComponent(To)}`);
        return axios.get(`api/admin/Pharmacy/GetOrders?${params.join('&')}`);
    },
    GetPharmacyStatistics(BranchesId) {
        const q = (BranchesId !== undefined && BranchesId !== null && BranchesId !== '')
            ? `?BranchesId=${BranchesId}`
            : '';
        return axios.get(`api/admin/Pharmacy/GetStatistics${q}`);
    },
    GetPharmacyOrder(id) {
        return axios.get(`api/admin/Pharmacy/GetOrder/${id}`);
    },
    ReviewPharmacyOrder(id, body) {
        return axios.post(`api/admin/Pharmacy/ReviewOrder/${id}`, body);
    },



}